<template>
  <div id="wrapper" class="font-fira">
    <TextHeader :headerTitle="$t('tours.title')" />
    <div id="content" class="w-container">
      <p class="paragraph" v-html="$t('tours.p1')" />
      <p class="paragraph mb-4" v-html="$t('tours.p2')" />
      <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/tours/03.jpg" alt="Madrigal Choir during tour in France in 2018"/>
      <p class="section-heading" v-html="$t('tours.s1')" />
      <div class="underline-bar"></div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.at')"/>
        <div>
          <span class="badge badge-secondary mr-2">1969</span>
          <span class="badge badge-secondary mr-2">1971 (2)</span>
          <span class="badge badge-secondary mr-2">1972</span>
          <span class="badge badge-secondary mr-2">1974</span>
          <span class="badge badge-secondary">2014</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.be')"/>
        <div>
          <span class="badge badge-secondary mr-2">1968</span>
          <span class="badge badge-secondary mr-2">1972</span>
          <span class="badge badge-secondary mr-2">1980</span>
          <span class="badge badge-secondary mr-2">1995</span>
          <span class="badge badge-secondary mr-2">1997</span>
          <span class="badge badge-secondary">2014</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.bg')"/>
        <div>
          <span class="badge badge-secondary mr-2">1967</span>
          <span class="badge badge-secondary mr-2">1972</span>
          <span class="badge badge-secondary mr-2">1973</span>
          <span class="badge badge-secondary mr-2">1982</span>
          <span class="badge badge-secondary">1987</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.ca')"/>
        <div>
          <span class="badge badge-secondary mr-2">1984</span>
          <span class="badge badge-secondary">1988</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.cz')"/>
        <div>
          <span class="badge badge-secondary mr-2">1966</span>
          <span class="badge badge-secondary mr-2">1969</span>
          <span class="badge badge-secondary mr-2">1973</span>
          <span class="badge badge-secondary mr-2">1976</span>
          <span class="badge badge-secondary">1985</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.cn')"/>
        <div>
          <span class="badge badge-secondary">2014</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.kp')"/>
        <div>
          <span class="badge badge-secondary">1987</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.hr')"/>
        <div>
          <span class="badge badge-secondary">2022</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.dk')"/>
        <div>
          <span class="badge badge-secondary mr-2">1971</span>
          <span class="badge badge-secondary">1995</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.ch')"/>
        <div>
          <span class="badge badge-secondary mr-2">1971</span>
          <span class="badge badge-secondary mr-2">1972</span>
          <span class="badge badge-secondary mr-2">1986</span>
          <span class="badge badge-secondary mr-2">2002</span>
          <span class="badge badge-secondary mr-2">2016</span>
          <span class="badge badge-secondary">2018</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.fi')"/>
        <div>
          <span class="badge badge-secondary mr-2">1974</span>
          <span class="badge badge-secondary">1986</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.fr')"/>
        <div>
          <span class="badge badge-secondary mr-2">1966</span>
          <span class="badge badge-secondary mr-2">1969 (2)</span>
          <span class="badge badge-secondary mr-2">1970 (2)</span>
          <span class="badge badge-secondary mr-2">1978</span>
          <span class="badge badge-secondary mr-2">1992 (2)</span>
          <span class="badge badge-secondary mr-2">1993 (2)</span>
          <span class="badge badge-secondary mr-2">1995</span>
          <span class="badge badge-secondary mr-2">1996</span>
          <span class="badge badge-secondary">2018</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.de')"/>
        <div>
          <span class="badge badge-secondary mr-2">1965</span>
          <span class="badge badge-secondary mr-2">1967</span>
          <span class="badge badge-secondary mr-2">1970</span>
          <span class="badge badge-secondary mr-2">1971 (2)</span>
          <span class="badge badge-secondary mr-2">1973 (2)</span>
          <span class="badge badge-secondary mr-2">1974</span>
          <span class="badge badge-secondary mr-2">1976</span>
          <span class="badge badge-secondary mr-2">1977</span>
          <span class="badge badge-secondary mr-2">1979</span>
          <span class="badge badge-secondary mr-2">1980 (2)</span>
          <span class="badge badge-secondary mr-2">1981</span>
          <span class="badge badge-secondary mr-2">1983 (2)</span>
          <span class="badge badge-secondary mr-2">1984</span>
          <span class="badge badge-secondary mr-2">1985 (2)</span>
          <span class="badge badge-secondary mr-2">1986</span>
          <span class="badge badge-secondary mr-2">1987</span>
          <span class="badge badge-secondary mr-2">1988 (2)</span>
          <span class="badge badge-secondary mr-2">1991</span>
          <span class="badge badge-secondary mr-2">1992</span>
          <span class="badge badge-secondary mr-2">1993</span>
          <span class="badge badge-secondary mr-2">1995</span>
          <span class="badge badge-secondary mr-2">1997</span>
          <span class="badge badge-secondary mr-2">1999</span>
          <span class="badge badge-secondary mr-2">2002</span>
          <span class="badge badge-secondary mr-2">2004</span>
          <span class="badge badge-secondary mr-2">2012</span>
          <span class="badge badge-secondary mr-2">2013</span>
          <span class="badge badge-secondary mr-2">2015</span>
          <span class="badge badge-secondary mr-2">2019</span>
          <span class="badge badge-secondary">2022</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.gr')"/>
        <div>
          <span class="badge badge-secondary mr-2">1978</span>
          <span class="badge badge-secondary mr-2">1985</span>
          <span class="badge badge-secondary mr-2">2002</span>
          <span class="badge badge-secondary">2005</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.il')"/>
        <div>
          <span class="badge badge-secondary">2017</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.it')"/>
        <div>
          <span class="badge badge-secondary mr-2">1967</span>
          <span class="badge badge-secondary mr-2">1971 (2)</span>
          <span class="badge badge-secondary mr-2">1973</span>
          <span class="badge badge-secondary mr-2">1974</span>
          <span class="badge badge-secondary mr-2">1975 (3)</span>
          <span class="badge badge-secondary mr-2">1976</span>
          <span class="badge badge-secondary mr-2">1977</span>
          <span class="badge badge-secondary mr-2">1985 (3)</span>
          <span class="badge badge-secondary mr-2">1986 (2)</span>
          <span class="badge badge-secondary mr-2">1990</span>
          <span class="badge badge-secondary mr-2">1991</span>
          <span class="badge badge-secondary mr-2">1993</span>
          <span class="badge badge-secondary mr-2">1994</span>
          <span class="badge badge-secondary mr-2">1996</span>
          <span class="badge badge-secondary">2021</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.yu')"/>
        <div>
          <span class="badge badge-secondary mr-2">1967</span>
          <span class="badge badge-secondary mr-2">1968</span>
          <span class="badge badge-secondary mr-2">1969 (3)</span>
          <span class="badge badge-secondary mr-2">1970</span>
          <span class="badge badge-secondary mr-2">1971</span>
          <span class="badge badge-secondary mr-2">1973</span>
          <span class="badge badge-secondary mr-2">1974</span>
          <span class="badge badge-secondary">1978</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.jp')"/>
        <div>
          <span class="badge badge-secondary mr-2">1990</span>
          <span class="badge badge-secondary">2005</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.lv')"/>
        <div>
          <span class="badge badge-secondary">2014</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.lt')"/>
        <div>
          <span class="badge badge-secondary">2014</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.li')"/>
        <div>
          <span class="badge badge-secondary mr-2">1980</span>
          <span class="badge badge-secondary mr-2">1983</span>
          <span class="badge badge-secondary mr-2">1992</span>
          <span class="badge badge-secondary">1995</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.lu')"/>
        <div>
          <span class="badge badge-secondary mr-2">1974</span>
          <span class="badge badge-secondary mr-2">1979</span>
          <span class="badge badge-secondary mr-2">1980</span>
          <span class="badge badge-secondary mr-2">1983</span>
          <span class="badge badge-secondary">1988</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.gb')"/>
        <div>
          <span class="badge badge-secondary mr-2">1967</span>
          <span class="badge badge-secondary mr-2">1970</span>
          <span class="badge badge-secondary mr-2">1973</span>
          <span class="badge badge-secondary mr-2">1975</span>
          <span class="badge badge-secondary mr-2">1981</span>
          <span class="badge badge-secondary mr-2">1999</span>
          <span class="badge badge-secondary">2018</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.md')"/>
        <div>
          <span class="badge badge-secondary mr-2">1990</span>
          <span class="badge badge-secondary">1995</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.no')"/>
        <div>
          <span class="badge badge-secondary">1971</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.nl')"/>
        <div>
          <span class="badge badge-secondary mr-2">1969</span>
          <span class="badge badge-secondary mr-2">1980 (2)</span>
          <span class="badge badge-secondary mr-2">1983</span>
          <span class="badge badge-secondary mr-2">1985</span>
          <span class="badge badge-secondary mr-2">1988</span>
          <span class="badge badge-secondary mr-2">1995</span>
          <span class="badge badge-secondary mr-2">1997</span>
          <span class="badge badge-secondary mr-2">1999</span>
          <span class="badge badge-secondary">2002</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.pl')"/>
        <div>
          <span class="badge badge-secondary mr-2">1966</span>
          <span class="badge badge-secondary mr-2">1972</span>
          <span class="badge badge-secondary mr-2">1974</span>
          <span class="badge badge-secondary mr-2">1976</span>
          <span class="badge badge-secondary mr-2">1978 (2)</span>
          <span class="badge badge-secondary mr-2">1979</span>
          <span class="badge badge-secondary mr-2">1980</span>
          <span class="badge badge-secondary mr-2">1983</span>
          <span class="badge badge-secondary mr-2">1997</span>
          <span class="badge badge-secondary mr-2">2000</span>
          <span class="badge badge-secondary">2008</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.pt')"/>
        <div>
          <span class="badge badge-secondary">2018</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.sm')"/>
        <div>
          <span class="badge badge-secondary">1971</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.rs')"/>
        <div>
          <span class="badge badge-secondary mr-2">1995</span>
          <span class="badge badge-secondary mr-2">1997</span>
          <span class="badge badge-secondary">2022</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.es')"/>
        <div>
          <span class="badge badge-secondary mr-2">1968</span>
          <span class="badge badge-secondary mr-2">1970</span>
          <span class="badge badge-secondary mr-2">1991 (3)</span>
          <span class="badge badge-secondary mr-2">1992</span>
          <span class="badge badge-secondary mr-2">1993</span>
          <span class="badge badge-secondary">1994</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.se')"/>
        <div>
          <span class="badge badge-secondary">1974</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.tr')"/>
        <div>
          <span class="badge badge-secondary mr-2">1973</span>
          <span class="badge badge-secondary mr-2">1975</span>
          <span class="badge badge-secondary mr-2">1976</span>
          <span class="badge badge-secondary mr-2">1981</span>
          <span class="badge badge-secondary mr-2">1987</span>
          <span class="badge badge-secondary mr-2">1992</span>
          <span class="badge badge-secondary mr-2">1994</span>
          <span class="badge badge-secondary">1998</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.hu')"/>
        <div>
          <span class="badge badge-secondary mr-2">1966</span>
          <span class="badge badge-secondary mr-2">1969</span>
          <span class="badge badge-secondary mr-2">1976</span>
          <span class="badge badge-secondary mr-2">1990</span>
          <span class="badge badge-secondary">1998</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.ru')"/>
        <div>
          <span class="badge badge-secondary mr-2">1969</span>
          <span class="badge badge-secondary mr-2">1973</span>
          <span class="badge badge-secondary">1974</span>
        </div>
      </div>
      <div class="mb-3">
        <div class="font-weight-bold" v-html="$t('tours.us')"/>
        <div>
          <span class="badge badge-secondary mr-2">1969</span>
          <span class="badge badge-secondary mr-2">1978 (2)</span>
          <span class="badge badge-secondary mr-2">1984</span>
          <span class="badge badge-secondary">1988</span>
        </div>
      </div>
      <div class="mb-4">
        <div class="font-weight-bold" v-html="$t('tours.va')"/>
        <div>
          <span class="badge badge-secondary">1994</span>
        </div>
      </div>
      <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/tours/02.jpg" alt="Madrigal Choir during tour in China"/>
    </div>
  </div>
</template>
<script>
  import TextHeader from "./TextHeader";
  export default {
    name: "Tours",
    components: { TextHeader },
    data() {}
  }
</script>
<style style scoped lang="scss">
  #content {
    font-family: Fira Sans,sans-serif;
    font-size: 1.3em;
    line-height: 25px;
    font-weight: 400;
    padding: 60px 0;
  }

  @media screen and (max-width: 1155px) {
    #content {
      padding: 60px 7px;
    }
  }

  .paragraph {
    line-height: 30px;
    font-weight: 600;
  }

  .section-heading {
    font-size: 1.4em;
    line-height: 45px;
    margin-bottom: 10px;
    margin-top: 30px;
    font-weight: bold;
  }

  .underline-bar {
    background-color: #333;
    height: 3px;
    width: 120px;
    margin-bottom: 20px;
  }
</style>